module.exports = __webpack_public_path__ + "img/CS0000_default.a049af14.png";